// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".makePaymentForDueAmountModal {\n  width: 100%;\n  height: auto;\n}\n\n.makePaymentForDueAmountModal > p {\n  font-style: normal;\n  font-weight: bold;\n  font-size: 14px;\n  color: #666666;\n  margin-bottom: 0;\n}\n\n.makePaymentForDueAmountModal > h3 {\n  font-style: normal;\n  font-weight: bold;\n  font-size: 18px;\n  color: #000000;\n}", ""]);
// Exports
module.exports = exports;
